import { Check, CheckCheck } from "lucide-react";

// Chiave giorno LOCALE (dopo conversione nel fuso del dispositivo) dal timestamp UTC autorevole del server.
export function localDayKey(iso) {
  const d = new Date(iso);
  return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
}

// Etichetta separatore: Oggi / Ieri / data localizzata. locale = lingua attiva (it/en/fr/de).
export function dayLabel(iso, t, locale) {
  const d = new Date(iso);
  const now = new Date();
  const key = localDayKey(iso);
  const today = `${now.getFullYear()}-${now.getMonth()}-${now.getDate()}`;
  const y = new Date(now); y.setDate(now.getDate() - 1);
  const yKey = `${y.getFullYear()}-${y.getMonth()}-${y.getDate()}`;
  if (key === today) return t("chat.today");
  if (key === yKey) return t("chat.yesterday");
  return d.toLocaleDateString(locale || undefined, { day: "2-digit", month: "long", year: "numeric" });
}

// Ora locale a due cifre HH:mm (24h) dal timestamp UTC del server.
export function timeHHmm(iso, locale) {
  return new Date(iso).toLocaleTimeString(locale || undefined, { hour: "2-digit", minute: "2-digit", hour12: false });
}

// Stato reale (mai dedotto dall'invio): read -> 'read'; delivered_at -> 'delivered'; altrimenti 'sent'.
// null per i messaggi ricevuti (nessuna spunta sui messaggi altrui).
export function messageStatus(m, myId) {
  if (!m || m.from_id !== myId) return null;
  if (m.read) return "read";
  if (m.delivered_at) return "delivered";
  return "sent";
}

export function DaySeparator({ label }) {
  return (
    <div className="flex justify-center my-2" data-testid="chat-day-separator">
      <span className="text-[11px] text-slate-500 bg-slate-100 rounded-full px-3 py-0.5">{label}</span>
    </div>
  );
}

// Spunte solo sui messaggi propri. Significato distinto anche senza colore (forma + testo accessibile + tooltip):
// Inviato = 1 spunta; Consegnato = 2 spunte; Letto = 2 spunte evidenziate.
export function MessageTicks({ status, t }) {
  if (!status) return null;
  const label = t(`chat.st_${status}`);
  return (
    <span role="img" aria-label={label} title={label} data-testid={`msg-tick-${status}`} className="inline-flex items-center">
      {status === "sent"
        ? <Check size={14} aria-hidden="true" />
        : <CheckCheck size={14} aria-hidden="true" className={status === "read" ? "text-emerald-300" : ""} />}
    </span>
  );
}
